import { Group, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./TitledHeader.module.css";

export interface TitledHeaderProps {
  title: string;
  subtitle?: string;
  /** Actions at the right of the title. */
  right?: ReactNode;
  /** The heading level: 2 under a page's h1, 3 below that. */
  order?: 2 | 3;
}

/** A section's 16px title, an optional muted subtitle and actions, 16px above its content. */
export function TitledHeader({ title, subtitle, right, order = 2 }: TitledHeaderProps) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" mb="md">
      <Stack gap={2}>
        <Title order={order} className={classes.title}>
          {title}
        </Title>
        {subtitle === undefined ? null : <Text className={classes.subtitle}>{subtitle}</Text>}
      </Stack>
      {right}
    </Group>
  );
}
